<template>
  <div>
    <!-- 영문 이름 -->
    <div class="item">
      <div class="sub-title">
        {{ "영문 이름" }}
        <span class="keyColor">{{ $t("Verification.common.required") }}</span>
      </div>
      <div v-if="true" class="input-box authID" flex fjb>
        <div class="detail half en-name">
          {{ step2cpndata.enSurname }}
        </div>
        <div class="detail half en-name">
          {{ step2cpndata.enGivenName }}
        </div>
      </div>
    </div>
    <!-- //영문 이름 -->
    <!-- 여권 번호 -->
    <div class="item">
      <div class="sub-title">
        {{ "여권 번호" }}
        <span class="keyColor">{{ $t("Verification.common.required") }}</span>
      </div>
      <div class="input-box authID" flex>
        <el-input
          v-model="data.passportNumber"
          type="text"
          @input="checkNumberLength"
          placeholder="여권 번호를 입력해 주세요."
          class="en-name"
        ></el-input>
      </div>
    </div>
    <!-- //여권 번호 -->
    <!-- 생년월일 -->
    <div class="item">
      <div class="sub-title">
        {{ "생년월일" }}
        <span class="keyColor">{{ $t("Verification.common.required") }}</span>
      </div>
      <div class="input-box authID" flex>
        <el-date-picker
          v-model="data.foreignerbirth"
          type="date"
          placeholder="날짜를 선택해 주세요."
          class="idcard-start"
        ></el-date-picker>
      </div>
    </div>
    <!-- //생년월일 -->
    <!-- 성별 -->
    <div class="item">
      <div @click="openGenderModal" class="item">
        <div class="sub-title">
          {{ "성별" }}
          <span class="keyColor">{{ $t("Verification.common.required") }}</span>
        </div>
        <div class="detail dropdown">
          {{
            data.genderList == "0" ? "성별을 선택해 주세요." : data.genderList
          }}
        </div>
      </div>
    </div>
    <!-- //성별 -->
    <!-- 휴대폰 번호 -->
    <div class="item">
      <div class="sub-title">
        {{ "휴대폰 번호" }}
      </div>
      <div class="detail">
        {{ cntlocalcode + step2cpndata.personalCode }}
      </div>
    </div>
    <!-- //휴대폰 번호 -->
    <!-- 주소 -->
    <div class="item">
      <div class="sub-title">
        {{ "주소" }}
        <span class="keyColor">{{ $t("Verification.common.required") }}</span>
      </div>
      <div class="input-box authID">
        <el-input
          type="number"
          v-model="data.searchData.addr1"
          pattern="\d*"
          placeholder="(우편번호) 주소 입력"
          class="en-name"
        />
        <el-input
          type="text"
          v-model="data.searchData.addr2"
          placeholder="기본 주소 입력"
          class="en-name mt8"
        />
        <el-input
          type="text"
          v-model="data.searchData.addr3"
          placeholder="상세 주소 입력"
          class="en-name mt8"
        />
      </div>
    </div>
    <!-- //주소 -->

    <div class="keycolor fs10 mt20">
      {{ "본인이 아닌 정보를 입력하시면 입출금 및 이용에 제약을 받습니다." }}
    </div>
    <div class="bottom-button-wrap bottom mt30" flex fjb>
      <button @click="toStep2" class="next-button pre">
        {{ "이전" }}
      </button>
      <button
        @click="toTowThird"
        :disabled="
          this.data.passportNumber == '' ||
            this.data.foreignerbirth == '' ||
            this.data.genderList == '0' ||
            this.data.searchData.addr1 == '' ||
            this.data.searchData.addr2 == ''
        "
        class="next-button next"
      >
        다음
      </button>
    </div>
    <!-- 성별 팝업 -->
    <el-dialog
      :visible.sync="data.genderModal"
      title="성별 선택"
      :close-on-click-modal="false"
      class="authID-modal"
    >
      <el-radio-group v-model="data.genderList" @change="changeGenderModal">
        <ul class="dropdown-list">
          <li v-for="(item, index) in data.genderItems" :key="index">
            <el-radio :label="item.gender"></el-radio>
          </li>
        </ul>
      </el-radio-group>
    </el-dialog>
    <!-- //성별 팝업 -->
  </div>
</template>

<script>
export default {
  props: {
    data: {
      passportNumber: String, //여권 번호
      foreignerbirth: String, //생년월일
      genderModal: Boolean, //성별 선택 팝업
      genderList: String, //성별 선택 list v-model
      genderItems: Array, //성별 선택 data
      // 기본정보 주소
      searchData: {
        addr1: String,
        addr2: String,
        addr3: String,
      },
    },
    cntlocalcode: String, //통신사 국가 코드
    step2cpndata: {
      enSurname: String, //영문 성
      enGivenName: String, //영문 이름
      personalCode: String, // 휴대폰 번호
    },
  },
  methods: {
    //input type number 입력수 제한
    checkNumberLength() {
      if (this.data.passportNumber.length > 20) {
        this.data.passportNumber = this.data.passportNumber.slice(0, 20);
      }
    },
    //성별 선택 모달
    openGenderModal() {
      this.data.genderModal = true;
    },
    //성별 선택 시
    changeGenderModal() {
      this.data.genderModal = false; //팝업 닫힘
    },
    //step2로 이동
    toStep2() {
      this.$emit("tostep2");
    },
    toTowThird() {
      this.$emit("totowthird");
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  margin-top: 12px;
  .sub-title {
    margin-bottom: 8px;
    font-size: 12px;
    font-weight: normal;
    line-height: 1.5;
    color: #333;
  }
  .authID {
    .search-address {
      width: 62px;
      padding: 10px 0px 11px;
      font-size: 12px;
      color: #333;
      border: 1px solid #dcdfe3;
      border-radius: 0 2px 2px 0;
      background-color: #fff;
    }
    .one-fifth {
      width: calc(100% - 62px);
      border: 1px solid #dcdfe3;
      border-right: 0 solid;
      border-right: 0;
      border-radius: 2px 0 0 2px;
    }
  }
  .detail {
    padding: 11px 0 11px 8px;
    border-radius: 2px;
    border: solid 1px #dcdfe3;
    background-color: #f7f8fa;
    &.full-box {
      height: 38px;
      color: #333;
      background-color: #fff;
    }
    &.dropdown {
      position: relative;
      color: #afafaf;
      background-color: #fff;
      &:after {
        content: "";
        position: absolute;
        top: 13px;
        right: 9px;
        width: 6.7px;
        height: 12px;
        background-image: url("../../../../../../assets/img/mypage/button_arrow_right_icon.svg");
        background-size: 6.7px 12px;
        background-repeat: no-repeat;
      }
      &.selected {
        color: #333;
        border: solid 1px #00b473;
        background-color: #f2fbf8;
      }
      &.change {
        color: #333;
        border: solid 1px #00b473;
        background-color: #f2fbf8;
      }
      &.reject {
        color: #333;
        border: solid 1px #eb3246;
        background-color: #fff;
      }
    }
  }
  .input-box {
    .en-name.half {
      width: calc((100% - 12px) / 2);
    }
  }
}
.dropdown-list {
  list-style: none;
  li {
    padding: 20px 12px;
    font-size: 12px;
    font-weight: 500;
    &.padding-change {
      padding: 11px 12px;
    }
    .detail {
      padding-left: 27px;
      margin-bottom: 2px;
      font-size: 10px;
      font-weight: normal;
      line-height: 1.8;
      color: #999;
    }
    .list-item-title {
      position: relative;
      padding-left: 20px;
      .arrow {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid #333;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        &.open {
          width: 0;
          height: 0;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          border-top: 6px solid #333;
          border-bottom: 0;
        }
      }
    }

    ul {
      list-style: none;
    }
  }

  &-description {
    font-size: 10px;
    color: #999;
    margin-top: 5px;
    font-weight: normal;
  }
}
// 하단 버튼
button.next-button {
  width: 100%;
  padding: 10px 0;
  font-size: 12px;
  border-radius: 2px;
  border: 1px solid #00b473;
  background-color: #00b473;
  &.pre {
    width: 96px;
    color: #333;
    border: 1px solid #eeeeee;
    background-color: #fff;
  }
  &.next {
    width: calc(100% - 104px);
  }
  &.bottom {
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 24px);
  }
  &:disabled {
    border: solid 1px #dadada !important;
    background-color: #dadada !important;
  }
}
.bottom-button-wrap {
  width: 100%;
}
</style>
